'use client';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@repo/utils/cn';
import * as React from 'react';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverArrow = PopoverPrimitive.Arrow;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    contentClassName?: string;
  }
>(({ className, contentClassName, align = 'center', sideOffset = 1, children, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'vt-containers-popover-bg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[100] rounded-[0.25rem] p-0 shadow-[6px_9px_20px_3px_rgba(0,0,0,0.4)] outline-none',
        className
      )}
      {...props}
    >
      <div className={cn('max-h-[310px] overflow-y-scroll', contentClassName)}>{children}</div>
      <PopoverArrow className="fill-[#262a40]" />
    </PopoverPrimitive.Content>
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
